import apiRequestService from '@/commonProject/service/apiRequestService';

export default class setupAgreeRepository {
    /**
     * ユーザー利用規定同意登録APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async postUserAgreementUpdateActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrreg', requestBody, idToken);
        return result;
    }
}
